import script from "./ConsumerMypageOrderView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumerMypageOrderView.vue?vue&type=script&setup=true&lang=js"

import "./ConsumerMypageOrderView.vue?vue&type=style&index=0&id=0c3f8547&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c3f8547"]])

export default __exports__